export const LIMITED_VIDEO_LANGUAGE_ACTIVITY_IDS = [
  "fc6b3a64-3dcb-4a98-b26e-bf3e67dce1a4",
  "8f4c2a9e-7b6d-4c1a-bf42-9d6e3a5f1c87",
];
